// Channeltivity partner portal. It blocks iframes and has no JS embed, so the site links out.
const CHANNELTIVITY_BASE_URL = 'https://secureframe.channeltivity.com'

export const CHANNELTIVITY_URLS = {
  BECOME_A_PARTNER: `${CHANNELTIVITY_BASE_URL}/BecomeAPartner`,
  LOGIN: `${CHANNELTIVITY_BASE_URL}/Login`,
  /** Login-gated: signed-out visitors land on /Login?target=/DealReg. */
  DEAL_REG: `${CHANNELTIVITY_BASE_URL}/DealReg`,
} as const
